export default __webpack_public_path__ + "static/media/hero-gradient-swoosh.f5f9028b.png";